function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getWindow } from '../services/window';
import { Constants } from '../utils/constants';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { SharedInstrumentService } from '../services/telemetry/shared/sharedInstrument';
import { getAppConfig } from '../services/init/appConfig';
import { stringifyError } from './errorUtils';
import { logger, systemLogger } from '@src/logger';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const jwtDecode = require('jwt-decode');
export const headersToRedact = {
    [Constants.Headers.Cookie.toLowerCase()]: true,
    [Constants.Headers.Authorization.toLowerCase()]: true,
    [Constants.Headers.InternalAuthorizationHeader.toLowerCase()]: true,
    [Constants.Headers.XForwardedFor.toLowerCase()]: true,
    [Constants.Headers.XIISNodeRemoteAddr.toLowerCase()]: true,
    [Constants.Headers.ApiKey.toLowerCase()]: true,
    [Constants.Headers.SetCookie.toLowerCase()]: true,
    [Constants.Headers.XMSAuthInternalToken.toLowerCase()]: true,
    [Constants.Headers.XAPIKey.toLowerCase()]: true,
    [Constants.Headers.XProofToken.toLowerCase()]: true,
    [Constants.Headers.ProxyAuthorization.toLowerCase()]: true
};
function generateTelemetryPayload(error, operationName) {
    const _details = {};
    _details.operation = operationName;
    _details.error = error || '';
    if (typeof error !== 'string') {
        _details.error = stringifyError(error);
    }
    let page = 'server';
    if (getAppConfig('runtimeEnvironment') === 'browser') {
        page = getWindow().location.href;
    }
    return {
        page,
        action: Constants.Telemetry.Action.NetworkCall,
        actionModifier: Constants.Telemetry.ActionModifier.Error,
        details: _details
    };
}
function parseURL(url) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    const reURLInformation = new RegExp([
        '^(https?:)//',
        '(([^:/?#]*)(?::([0-9]+))?)',
        '(/{0,1}[^?#]*)',
        '(\\?[^#]*|)',
        '(#.*|)$'
    ].join(''));
    const match = url.match(reURLInformation);
    if (!match) {
        return {};
    } else {
        return {
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            pathname: match[5],
            search: match[6],
            hash: match[7]
        };
    }
}
/**
 * This method removes the values of headers which contains PII or sensitive information.
 * The object returned will maintain the keys, but the senstive header values will be replaced with 'SCRUBBED (Length X)'
 * i.e.
 * {Authorization: SCRUBBED (Length 160), x-ms-correlationId: 04056106-cf0c-40cc-8e68-d657442da7ad\}
 */ export function scrubHeaders(headers) {
    return Object.fromEntries(Object.entries(headers).map(([key, value])=>{
        if (headersToRedact[`${key.toLowerCase()}`]) {
            var _headers_;
            value = `${Constants.scrubbedHeaderValue} (Length ${(_headers_ = headers[`${key}`]) === null || _headers_ === void 0 ? void 0 : _headers_.length})`;
        }
        return [
            key,
            value
        ];
    }));
}
function logOutRequestEventInfo(telemetry) {
    SharedInstrumentService.getProvider().probe('logOutRequestEventInfo', telemetry);
}
export function logError(operationName, error) {
    var _error_response, _error_response1;
    const instrument = SpzaInstrumentService.getProvider();
    let code = '';
    if (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.statusCode) {
        code = error.response.statusCode.toString();
    }
    const payload = generateTelemetryPayload(`${error}. Code: ${code}. Error details: ${error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.text}`, operationName);
    instrument.probe('logAndFlushTelemetryInfo', payload);
    logger.error(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        page: payload.page
    });
}
function parseRequest(request, taskName) {
    let operationName;
    if (getAppConfig('runtimeEnvironment') === 'browser') {
        operationName = getWindow().location.href;
    } else {
        operationName = 'server';
    }
    const requestHeaders = request.header;
    const correlationId = requestHeaders && requestHeaders[Constants.Headers.CorrelationId] || '';
    const requestId = requestHeaders && requestHeaders[Constants.Headers.RequestId] || '';
    const parsedUrl = parseURL(request.url);
    const telemetry = {
        taskName,
        correlationId,
        requestId,
        operation: operationName,
        httpMethod: request.method,
        hostName: parsedUrl.host || '',
        targetUri: request.url,
        requestHeaders: JSON.stringify(scrubHeaders(requestHeaders))
    };
    return telemetry;
}
export function logOutRequestStart(request) {
    // Prevent recusrive logs
    if (request.url.indexOf('api/log') === -1 && request) {
        const telemetry = parseRequest(request, Constants.Telemetry.OutRequest.Start);
        logOutRequestEventInfo(telemetry);
        systemLogger.info({
            event: telemetry
        });
    }
}
// TODO: Merge commong code with logOutRequestError
export function logOutRequestEnd(request, response, durationInMilliseconds) {
    // Prevent recusrive logs
    if (request.url.indexOf('api/log') === -1 && request && response) {
        let taskName;
        let errorMessage;
        if (response.ok) {
            taskName = Constants.Telemetry.OutRequest.EndWithSuccess;
        } else if (response.clientError) {
            taskName = Constants.Telemetry.OutRequest.EndWithClientError;
            errorMessage = response.text;
        } else {
            taskName = Constants.Telemetry.OutRequest.EndWithServerError;
            errorMessage = response.text;
        }
        const requestStart = parseRequest(request, taskName);
        const contentLength = response.header && response.header['content-length'] && Number(response.header['content-length']) || 0;
        const requestEnd = _object_spread_props(_object_spread({}, requestStart), {
            durationInMilliseconds,
            httpStatusCode: response.status,
            errorMessage,
            contentLength,
            responseHeaders: JSON.stringify(scrubHeaders(response.header))
        });
        logOutRequestEventInfo(requestEnd);
        systemLogger.info({
            event: requestEnd
        });
    }
}
// TODO: Merge commong code with logOutRequestEnd
export function logOutRequestError(request, response, duration, error, parsingError) {
    // Prevent recusrive logs
    if (request.url.indexOf('api/log') === -1 && request && response) {
        const actionModifier = parsingError || response.clientError ? Constants.Telemetry.OutRequest.EndWithClientError : Constants.Telemetry.OutRequest.EndWithServerError;
        const requestStart = parseRequest(request, actionModifier);
        const errorMessage = stringifyError(error);
        const contentLength = response.header && response.header['content-length'] && Number(response.header['content-length']) || 0;
        const requestEnd = _object_spread_props(_object_spread({}, requestStart), {
            durationInMilliseconds: duration,
            httpStatusCode: response.status,
            errorMessage,
            contentLength,
            responseHeaders: JSON.stringify(scrubHeaders(response.header))
        });
        logOutRequestEventInfo(requestEnd);
        systemLogger.error({
            event: requestEnd
        });
    }
}
export function shouldRefreshToken(token) {
    if (__SERVER__) {
        return false;
    }
    const currentTime = Math.round(Date.now() / 1000);
    const tolerance = 5 * 60;
    try {
        const decodedToken = token ? jwtDecode(token) : null;
        if (decodedToken) {
            if (typeof decodedToken.exp === 'number') {
                const expiryTime = decodedToken.exp;
                if (expiryTime - currentTime < tolerance) {
                    return true;
                }
            }
        }
    } catch (err) {
        return true;
    }
    return false;
}
